/* pdp-mobile-tabs.js — "Acerca de este producto": agrupa las 5 secciones del
   PDP (Ficha técnica / Cómo utilizar / Variantes de la línea / Descripción /
   Preguntas frecuentes) en pestañas, SOLO en móvil y tablet vertical
   (≤1023.98px — mismo punto donde el layout ya pasa a columna única).

   FAQ SÍ ES PESTAÑA (decisión explícita del usuario, revierte la fase
   anterior): antes el FAQ quedaba fuera del grupo por ser contenido de
   política de tienda repetido en todo el catálogo. El usuario pidió
   expresamente incluirlo como quinta pestaña, en este orden fijo: Ficha
   Técnica, Cómo Utilizar, Variantes del producto de la misma línea,
   Descripción, Preguntas Frecuentes -- igual al HTML de referencia. Sigue
   siendo la misma y única sección `__pdp_faq` que renderiza pdp-faq.liquid,
   con sus preguntas intactas -- no se duplica ni se reparenta.

   Diseño deliberado: NO se mueve (reparent) ningún nodo del DOM. Cada sección
   sigue siendo exactamente el mismo <div id="shopify-section-...__xxx"> que
   ya renderiza su propio archivo .liquid, con toda su lógica/JS intacta
   (botones "Copiar tabla"/"Descargar PDF" de variantes, el <read-more> de la
   descripción, los <details> del FAQ). Este componente solo:
     1) detecta cuáles de las 5 tienen contenido real (su propio Liquid ya las
        deja vacías -- sin texto -- cuando no hay datos: mismo criterio que el
        audit de contenido usa para "presente"/"vacío"),
     2) construye una barra de pestañas SOLO con las que sí tienen contenido,
        respetando el orden fijo de arriba,
     3) alterna display:none entre ellas (nunca oculta más de una si solo hay
        una disponible: en ese caso no hay pestañas, se muestra directo),
     4) en escritorio / editor de temas, no hace nada (todo se ve apilado,
        igual que hoy).
   Vanilla JS + Custom Elements (misma sintaxis que ReadMore/MediaGallery en
   theme.js), sin librerías. */
(function () {
  'use strict';
  if (customElements.get('pdp-mobile-tabs')) return;

  // ORDEN FIJO pedido por el usuario (igual al HTML de referencia), sin
  // depender del orden real del DOM: Ficha Técnica · Cómo Utilizar ·
  // Variantes del producto de la misma línea · Descripción · Preguntas
  // Frecuentes. collectPanels() recorre este arreglo en este orden, así que
  // los botones de pestaña salen siempre así aunque las secciones vivan en
  // otro orden en templates/product.json.
  //
  // OJO: __rich_text_fnkb9c (la descripción vieja, que imprime
  // {{ product.description }}) sigue existiendo en la plantilla, pero NO es
  // pestaña: si estuviera también como pestaña, el mismo contenido saldría dos
  // veces en el mismo viewport. Mientras el metacampo pdp.descripcion_comercial
  // esté vacío, __pdp_descripcion no renderiza nada y simplemente no aparece
  // pestaña de Descripción -- sin tarjeta vacía y sin texto inventado. Mismo
  // criterio para __pdp_faq: si no hay bloques de pregunta visibles, no
  // aparece pestaña de FAQ.
  var TABS = [
    { suffix: '__ficha_tecnica_maha', label: 'Ficha Técnica' },
    { suffix: '__pdp_como_utilizar', label: 'Cómo Utilizar' },
    { suffix: '__ficha_variantes_maha', label: 'Variantes del producto de la misma línea' },
    { suffix: '__pdp_descripcion', label: 'Descripción' },
    { suffix: '__pdp_faq', label: 'Preguntas Frecuentes' }
  ];
  var BREAKPOINT = '(max-width: 1023.98px)';

  // OJO: cada sección de Shopify SIEMPRE emite su <style data-shopify> con el
  // CSS scoped de esa sección (incluso vacía) como hijo directo del contenedor
  // -- y ese CSS es texto, así que element.textContent SIEMPRE tendría
  // longitud > 0 aunque no haya ningún dato real (bug detectado en vivo:
  // ficha_tecnica_maha vacía "parecía" tener ~1898 chars de contenido, que en
  // realidad eran sus propias reglas CSS). Por eso se itera SOLO los hijos de
  // nivel superior, excluyendo <style>/<script>/nuestra propia barra de tabs.
  function hasRealContent(el) {
    if (!el) return false;
    var text = '';
    var hasMedia = false;
    for (var i = 0; i < el.children.length; i++) {
      var child = el.children[i];
      var tag = child.tagName;
      if (tag === 'STYLE' || tag === 'SCRIPT' || tag === 'LINK' || tag === 'PDP-MOBILE-TABS') continue;
      text += child.textContent || '';
      if (!hasMedia && child.querySelector && child.querySelector('img, svg, table, button, a[href]')) hasMedia = true;
    }
    return text.trim().length > 0 || hasMedia;
  }

  class PdpMobileTabs extends HTMLElement {
    constructor() {
      super();
      this.mql = window.matchMedia(BREAKPOINT);
      this.activeIndex = -1;
      this.withContent = [];
      this.panels = [];
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
      this.onNavClick = this.onNavClick.bind(this);
      this.onNavKeydown = this.onNavKeydown.bind(this);
    }

    connectedCallback() {
      // CRÍTICO (bug real detectado en vivo vía Playwright -- "Maximum call
      // stack size exceeded" en TODAS las cargas de PDP, corregido antes de
      // este push): mover un custom element ya conectado con insertBefore()
      // SIEMPRE dispara disconnectedCallback + connectedCallback de nuevo de
      // forma síncrona (comportamiento estándar de Custom Elements, no un
      // bug del navegador). La versión anterior llamaba a insertBefore(this,
      // ...) DENTRO de connectedCallback sin ninguna guarda, así que cada
      // reentrada volvía a ejecutar el mismo insertBefore -> recursión
      // infinita -> stack overflow en cada carga de página.
      //
      // Arreglo: el reparenting ocurre UNA sola vez (guardado por
      // this._didReparent). La primera invocación (posición original, dentro
      // de ficha_tecnica_maha) solo localiza dónde debe vivir la barra y se
      // mueve; la invocación reentrante que ese mismo insertBefore() dispara
      // ya tiene _didReparent=true, así que en vez de repetir el movimiento
      // hace el setup real (crear nav, detectar contenido, pintar).
      if (this._didReparent) {
        this.setup();
        return;
      }
      this._didReparent = true;

      var firstPanelEl = null;
      for (var i = 0; i < TABS.length && !firstPanelEl; i++) {
        firstPanelEl = document.querySelector('[id$="' + TABS[i].suffix + '"]');
      }

      if (firstPanelEl) {
        // Reparenta el propio <pdp-mobile-tabs> (vacío, sin contenido real
        // de producto -- reparentar ESTO es seguro, no toca ningún dato) para
        // que quede HERMANO de los 5 paneles dentro de su mismo contenedor
        // (.main-content), en vez de quedar atrapado dentro de una sección
        // (ficha_tecnica_maha) que el propio render() oculta con
        // display:none cuando no está activa -- si la barra se quedara ahí
        // dentro, desaparecería junto con "Ficha técnica" cada vez que
        // cualquier OTRA pestaña estuviera activa. order:4 la deja siempre
        // justo antes del grupo de paneles (order 5-9 en pdp-maha.css),
        // después de recursos/pago/atributos (order:0).
        firstPanelEl.parentNode.insertBefore(this, firstPanelEl);
        this.style.order = '4';
        // El insertBefore de arriba ya disparó connectedCallback() de nuevo
        // (rama _didReparent) y ese setup() ya corrió -- no hay nada más que
        // hacer en esta invocación.
      } else {
        this.setup();
      }
    }

    setup() {
      if (this._setupDone) return;
      this._setupDone = true;

      // Tarjeta blanca exterior (mockup .about-card): título centrado +
      // flechas circulares + barra de pestañas, todo dentro del mismo
      // <pdp-mobile-tabs>. Nada de esto es contenido real de producto -- es
      // chrome del componente, igual que la barra misma ya lo era. El panel
      // visible queda visualmente "pegado" abajo por CSS (mismo truco de
      // antes), completando el aspecto de una sola tarjeta continua.
      this.titleEl = document.createElement('p');
      this.titleEl.className = 'pdp-tabs__title';
      this.titleEl.id = 'pdp-tabs-title-' + Math.random().toString(36).slice(2, 8);
      this.titleEl.textContent = 'Acerca de este producto';
      this.appendChild(this.titleEl);

      this.navWrap = document.createElement('div');
      this.navWrap.className = 'pdp-tabs__navwrap';

      this.prevBtn = document.createElement('button');
      this.prevBtn.type = 'button';
      this.prevBtn.className = 'pdp-tabs__arrow';
      this.prevBtn.setAttribute('aria-label', 'Anterior');
      this.prevBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';

      this.nav = document.createElement('div');
      this.nav.className = 'pdp-tabs__nav';
      this.nav.setAttribute('role', 'tablist');
      this.nav.setAttribute('aria-labelledby', this.titleEl.id);

      this.nextBtn = document.createElement('button');
      this.nextBtn.type = 'button';
      this.nextBtn.className = 'pdp-tabs__arrow';
      this.nextBtn.setAttribute('aria-label', 'Siguiente');
      this.nextBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';

      this.navWrap.appendChild(this.prevBtn);
      this.navWrap.appendChild(this.nav);
      this.navWrap.appendChild(this.nextBtn);
      this.appendChild(this.navWrap);

      this.onNavScroll = this.onNavScroll.bind(this);
      this.onWindowResize = this.onWindowResize.bind(this);
      this.prevBtn.addEventListener('click', this.onScrollPrev.bind(this));
      this.nextBtn.addEventListener('click', this.onScrollNext.bind(this));
      this.nav.addEventListener('scroll', this.onNavScroll, { passive: true });
      window.addEventListener('resize', this.onWindowResize);

      // En el editor de temas nunca se activa el modo tabs: todas las
      // secciones deben verse apiladas y editables con normalidad.
      this.isDesignMode = document.body.classList.contains('shopify-design-mode');

      this.collectPanels();
      this.render();

      if (this.mql.addEventListener) this.mql.addEventListener('change', this.onBreakpointChange);
      else if (this.mql.addListener) this.mql.addListener(this.onBreakpointChange); // Safari antiguo
      this.nav.addEventListener('click', this.onNavClick);
      this.nav.addEventListener('keydown', this.onNavKeydown);
    }

    // Flechas prev/next: navegación DISCRETA, una pestaña por clic (tarea UX
    // 2026-08-05 -- antes desplazaban la pista con scroll libre de ±140px por
    // clic, sin cambiar la pestaña activa). Solo se engancha aquí, en los
    // handlers de las flechas: la activación real la hace el mismo
    // setActive() interno que ya usan onNavClick y onNavKeydown, y
    // setActive -> render -> scrollActiveIntoView ya trae la pestaña nueva a
    // la vista, así que no hace falta ningún scroll manual. En la primera/
    // última pestaña el clic se ignora (la flecha además queda disabled vía
    // updateArrowState, ahora por índice). moveFocus=false: el foco se queda
    // en la flecha, como en cualquier carrusel accesible por puntero.
    onScrollPrev() {
      if (this.activeIndex > 0) this.setActive(this.activeIndex - 1, false);
    }

    onScrollNext() {
      var count = this.withContent ? this.withContent.length : 0;
      if (this.activeIndex < count - 1) this.setActive(this.activeIndex + 1, false);
    }

    onNavScroll() {
      this.updateArrowState();
    }

    onWindowResize() {
      this.scrollActiveIntoView();
    }

    // Enciende/apaga cada flecha según la POSICIÓN de la pestaña activa (ya
    // no según los extremos de scroll de la pista: las flechas ahora navegan
    // pestañas, no desplazan la pista): prev queda disabled en la primera
    // pestaña y next en la última. Se sigue llamando tras cada render y en
    // scroll/resize de la pista, donde ahora es simplemente idempotente.
    updateArrowState() {
      if (!this.nav || !this.prevBtn || !this.nextBtn) return;
      var count = this.withContent ? this.withContent.length : 0;
      this.prevBtn.disabled = this.activeIndex <= 0;
      this.nextBtn.disabled = count === 0 || this.activeIndex >= count - 1;
    }

    // Garantiza que la pestaña activa quede completamente visible dentro de
    // la pista (nunca escondida detrás de una flecha): si su borde izquierdo
    // quedó antes del borde visible, desplaza hacia atrás lo justo; si su
    // borde derecho quedó después, desplaza hacia adelante lo justo. No
    // centra -- solo la trae a la vista, como pide la tarea.
    scrollActiveIntoView() {
      if (!this.nav) return;
      var btn = this.nav.querySelector('.pdp-tabs__btn[aria-selected="true"]');
      if (!btn) { this.updateArrowState(); return; }
      var navRect = this.nav.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      if (btnRect.left < navRect.left) {
        this.nav.scrollBy({ left: btnRect.left - navRect.left - 8, behavior: 'smooth' });
      } else if (btnRect.right > navRect.right) {
        this.nav.scrollBy({ left: btnRect.right - navRect.right + 8, behavior: 'smooth' });
      }
      this.updateArrowState();
    }

    disconnectedCallback() {
      if (this.mql.removeEventListener) this.mql.removeEventListener('change', this.onBreakpointChange);
      else if (this.mql.removeListener) this.mql.removeListener(this.onBreakpointChange);
      if (this.nav) this.nav.removeEventListener('scroll', this.onNavScroll);
      window.removeEventListener('resize', this.onWindowResize);
    }

    collectPanels() {
      this.panels = [];
      for (var i = 0; i < TABS.length; i++) {
        var t = TABS[i];
        var el = document.querySelector('[id$="' + t.suffix + '"]');
        if (!el) continue;
        this.panels.push({ label: t.label, el: el, hasContent: hasRealContent(el) });
      }
    }

    onBreakpointChange() {
      this.collectPanels();
      this.render();
    }

    render() {
      var withContent = [];
      for (var i = 0; i < this.panels.length; i++) {
        if (this.panels[i].hasContent) withContent.push(this.panels[i]);
      }

      var shouldTab = this.mql.matches && !this.isDesignMode && withContent.length > 1;

      if (!shouldTab) {
        // Desktop, editor de temas, o 0/1 panel con contenido real: sin
        // tabs, cada sección se muestra tal cual (apiladas), como ya
        // funciona hoy. Se oculta también la tarjeta (título + flechas +
        // nav) como una sola unidad -- no debe quedar un título "Acerca de
        // este producto" huérfano sin pestañas debajo.
        this.classList.remove('pdp-tabs--active');
        this.nav.innerHTML = '';
        for (var j = 0; j < this.panels.length; j++) {
          var p = this.panels[j];
          p.el.classList.remove('pdp-tab-panel', 'pdp-tab-panel--active');
          p.el.removeAttribute('role');
          p.el.removeAttribute('aria-labelledby');
          p.el.style.display = '';
        }
        this.activeIndex = -1;
        this.withContent = [];
        return;
      }

      if (this.activeIndex < 0 || !withContent[this.activeIndex]) this.activeIndex = 0;

      this.nav.innerHTML = '';
      this.classList.add('pdp-tabs--active');

      // Paneles rastreados SIN contenido real (p.ej. descripción vacía para
      // este producto) también deben ocultarse explícitamente: su Liquid ya
      // no imprime nada visible, pero el wrapper de Shopify puede no ser
      // técnicamente :empty (deja un margen residual) y rompe la unión
      // visual entre la tarjeta de pestañas y el panel activo.
      for (var e = 0; e < this.panels.length; e++) {
        if (!this.panels[e].hasContent) {
          this.panels[e].el.classList.remove('pdp-tab-panel', 'pdp-tab-panel--active');
          this.panels[e].el.style.display = 'none';
        }
      }

      for (var k = 0; k < withContent.length; k++) {
        var panel = withContent[k];
        var isActive = k === this.activeIndex;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pdp-tabs__btn';
        btn.textContent = panel.label;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('data-index', String(k));
        var panelId = panel.el.id;
        btn.id = panelId + '-tab';
        btn.setAttribute('aria-controls', panelId);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.tabIndex = isActive ? 0 : -1;
        this.nav.appendChild(btn);

        panel.el.classList.add('pdp-tab-panel');
        panel.el.classList.toggle('pdp-tab-panel--active', isActive);
        panel.el.setAttribute('role', 'tabpanel');
        panel.el.setAttribute('aria-labelledby', btn.id);
        panel.el.style.display = isActive ? '' : 'none';
      }

      this.withContent = withContent;
      // La pestaña activa nunca debe quedar cortada/escondida detrás de una
      // flecha: se hace visible completa cada vez que cambia el set de
      // pestañas o cuál está activa.
      this.scrollActiveIntoView();
    }

    onNavClick(evt) {
      var btn = evt.target.closest ? evt.target.closest('.pdp-tabs__btn') : null;
      if (!btn) return;
      this.setActive(parseInt(btn.getAttribute('data-index'), 10), true);
    }

    onNavKeydown(evt) {
      var key = evt.key;
      if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
      evt.preventDefault();
      var count = this.withContent ? this.withContent.length : 0;
      if (!count) return;
      var next = this.activeIndex;
      if (key === 'ArrowLeft') next = (this.activeIndex - 1 + count) % count;
      else if (key === 'ArrowRight') next = (this.activeIndex + 1) % count;
      else if (key === 'Home') next = 0;
      else if (key === 'End') next = count - 1;
      this.setActive(next, true);
    }

    setActive(index, moveFocus) {
      if (!this.withContent || !this.withContent[index]) return;
      this.activeIndex = index;
      this.render();
      if (moveFocus) {
        var btn = this.nav.querySelector('[data-index="' + index + '"]');
        if (btn) btn.focus();
      }
    }
  }

  customElements.define('pdp-mobile-tabs', PdpMobileTabs);
})();
